/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation VendorInvoiceUpdateMutation($vendorInvoiceId: ID!, $amount: Float!, $invoiceNumber: String!, $datedOn: DateTime!, $billingStartDate: DateTime!, $billingEndDate: DateTime!) {
  VendorInvoiceUpdate(vendorInvoiceId: $vendorInvoiceId, amount: $amount, invoiceNumber: $invoiceNumber, datedOn: $datedOn, billingStartDate: $billingStartDate, billingEndDate: $billingEndDate) {
    id
    message
    status
  }
}
`
